import React, { useState, useRef, useEffect } from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { last, startCase, toLower } from "lodash";
import jsDig from "utils/jsDig";
import formatMetric from "utils/formatMetric";

export default function LiteMetricTable(props) {
  console.log(props)
  let shopifyIcon = require("images/lite/icons/shopify.png");
  shopifyIcon = <img className="table-icon" src={`/datapulse${shopifyIcon}`} />;
  let googleAds = require("images/lite/icons/google-ads.png");
  googleAds = <img className="table-icon" src={`/datapulse${googleAds}`} />;
  let microsoftAds = require("images/lite/icons/microsoft-ads.png");
  microsoftAds = <img className="table-icon" src={`/datapulse${microsoftAds}`} />;
  let searchIcon = require("images/lite/icons/search-icon.png");
  searchIcon = <img className="table-icon" src={`/datapulse${searchIcon}`} />;
  let socialIcon = require("images/lite/icons/social-icon.png");  
  let pinterest = require("images/lite/icons/pinterest.png");
  pinterest = <img className="table-icon" src={`/datapulse${pinterest}`} />;
  let youtube = require("images/lite/icons/youtube.png");
  youtube = <img className="table-icon" src={`/datapulse${youtube}`} />;
  socialIcon = <img className="table-icon" src={`/datapulse${socialIcon}`} />;
  let metaAds = require("images/lite/icons/meta.png");
  metaAds = <img className="table-icon" src={`/datapulse${metaAds}`} />;
  let tiktokAds = require("images/lite/icons/tiktok.png");
  tiktokAds = <img className="table-icon" src={`/datapulse${tiktokAds}`} />;
  let GoogleAnalytics = require("images/lite/icons/google-analytics.png");
  GoogleAnalytics = <img className="table-icon" src={`/datapulse${GoogleAnalytics}`} />;
  let semrush = require("images/lite/icons/semrush.png");
  semrush = <img className="table-icon" src={`/datapulse${semrush}`} />;
  let amazonAdsIcon = require("images/lite/icons/amazon-icon.png");
  amazonAdsIcon = <img className="table-icon" src={`/datapulse${amazonAdsIcon}`} />;
  let facebook = require("images/lite/icons/facebook.png");
  facebook = <img className="table-icon" src={`/datapulse${facebook}`} />;
  let amazon = require("images/lite/icons/amazon-icon.png");
  amazon = <img className="table-icon" src={`/datapulse${amazon}`} />;
  let chevronDown = require("images/lite/icons/chevron-down.png");
  chevronDown = <img className="table-icon" src={`/datapulse${chevronDown}`} />;
  let chevronUp = require("images/lite/icons/chevron-down.png");
  chevronUp = <img className="table-icon" src={`/datapulse${chevronUp}`} style={{
    transform: 'rotate(180deg)'
  }} />;


  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(props.groups && props.groups.length > 0 ? props.groups[0] : null);
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed || false);
  const dropdownRef = useRef(null);
  const tableContainerRef = useRef(null);
  const collapsible = props.collapsed == true || props.collapsed == false ? true : false;
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  
  useEffect(() => {
    // Adjust max-height based on the collapsed state and the content of the table
    const maxHeight = isCollapsed ? "0px" : `${tableContainerRef.current.scrollHeight}px`;
    tableContainerRef.current.style.maxHeight = maxHeight;
  }, [isCollapsed]);
  
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const selectGroup = (group) => {
    setSelectedGroup(group);
    setShowDropdown(false);
  };

  const baseUrl = props.baseUrl ? props.baseUrl.replace(/\/$/, "") : null;

  const renderGroupSelector = () => {
    if (!props.groups || props.groups.length === 0) {
      return null;
    }

    return (
      <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block', width: "170px" }}>
        <button onClick={toggleDropdown} style={{ color: 'white', backgroundColor: 'transparent', fontSize: '16px', cursor: 'pointer', display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", border: "none" }}>
          <span className="title-color-primary">{selectedGroup || 'Select Group'}</span>
          {!showDropdown ? <>{chevronDown}</> : <>{chevronUp}</>}
        </button>
        {showDropdown && (
          <div className="metric-table-group-selector" style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1
          }}>
            {props.groups.map((group) => (
              <div key={group} style={{ padding: '8px 12px', cursor: 'pointer', textAlign: 'left' }} onClick={() => selectGroup(group)}>
                {group}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderTopSummaryRow = () => {
    if (props.topSummaryRow) {
      const dim = jsDig(["dimension"], props.topSummaryRow);
      const topSummaryData = jsDig(["data"], props.topSummaryRow);
      return (
        <>
          <tr className="top-summary-row">
            <th className="dimension-column lite-table-cell ">{dim}</th>
            {props.headerOrder.map((metric, index) => {
              const metricName = toLower(metric);
              const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, "total"], topSummaryData) : jsDig([metricName, "total"], topSummaryData);
              return (
                <React.Fragment key={index}>
                  {metricValue ? 
                    formatCells(metricValue, metricName, false, false, false) : 
                    renderBlankRow(false)
                  }
                </React.Fragment>
              );
            })}
          </tr>
        </>
      )
    }
  }

  const renderTableHeader = () => {
    const columnWidth = 100 / (props.headerOrder.length + 1);
    return (
      <>
        <tr className="table-header">
          <th className=" lite-border-right lite-border-bottom"></th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return <th key={index} className={`${last == true ? "" : "lite-border-right"} lite-border-bottom`} colSpan={props.subHeaderOrder.length} style={{width: `${columnWidth}%`}}>{getColumnName(metric)}</th>;
          })}
        </tr>
        <tr className="table-header">
          <th className="first-th  lite-border-right lite-border-bottom"></th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return props.subHeaderOrder.map((subHeader, index) => {
              return <th className={`lite-border-bottom ${subHeader == "Y/Y" && last == false ? "lite-border-right yoy" : subHeader}-cell subheader-cell`} key={`${subHeader}-${index}`}>{subHeader}</th>;
            })
          })}
        </tr>
      </>
    )
  };

  const renderTableRows = () => {
    return props.dimensions.map((dim) => {
      const borderClass = dim.toLowerCase() === "ytd" ? "lite-border-top" : false;
      // Get the name of the current month
      const monthName = new Date().toLocaleString('en', { month: 'long' });
      let showProjection = false;
      if (dim.toLowerCase() == monthName.toLowerCase()) { showProjection = true; }
      if (dim.toLowerCase() == "ytd") { showProjection = true; }
      if (dim.toLowerCase() == "total") { showProjection = true; }
      return (
        <tr className="regular-row" key={dim}>
          <th className={`dimension-column lite-table-cell  lite-border-right ${borderClass ? borderClass : ""}`}>
            {dim}
            {(props.containsUrl && baseUrl && (dim != "(not set)")) && (
              <a href={`${baseUrl}${dim}`} target="_blank" rel="noreferrer" style={{marginLeft: "8px"}}>
                <i className="fas fa-external-link-alt"></i>
              </a>
            )}
          </th>
          {props.headerOrder.map((metric, index) => {
            const metricName = toLower(metric);
            const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, dim], props.data) : jsDig([metricName, dim], props.data);
            const last = props.headerOrder.length - 1 == index ? true : false
            return (
              <React.Fragment key={index}>
                {metricValue ? 
                  formatCells(metricValue, metricName, borderClass, last, showProjection) : 
                  renderBlankRow(borderClass)
                }
              </React.Fragment>
            );
          })}
        </tr>
      );
    })
  };

  const renderBlankRow = (borderClass) => {
    return (
      <>
        {
          props.subHeaderOrder.map((subHeader, index) => {
            return (
              <td className={`${borderClass ? borderClass : ""} ${index == 0 ? "" : ""} ${index == props.subHeaderOrder.length - 1 && last == false ? "lite-border-right" : ""}`} key={index}>
                <div className="lite-table-cell">&nbsp;</div>
              </td>
            )
          })
        }
      </>
    )
  }

  // Helper function to format individual metric
  const formatCells = (metric, metricName, borderClass, last, showProjection) => {
    return (
      <>
        {props.subHeaderOrder.map((subHeader, index) => {
          const thisYear = new Date().getFullYear();
          const lastYear = thisYear - 1;
          let metricValue = null;
          if (subHeader == lastYear) {
            metricValue = metric["previous"];
          } else if (subHeader == thisYear) {
            if (showProjection) {
              metricValue = metric["projection"];
            } else {
              metricValue = metric["current"];
            }
          } else if (subHeader == "Diff") {
            metricValue = metric["difference"];
          } else if (subHeader == "Y/Y") {
            if (showProjection) {
              metricValue = metric["projection_comparison"];
            } else {
              metricValue = metric["comparison"];
            }
          } else {
            metricValue = metric; // If the subheader doesn't match any expected values, assume it's a flat dataset with no groupings
          }

          {/* <td className={metric['comparison'] == null ? "" : (metric['comparison'] < 75) ? "percent-bad" : (metric['comparison'] >= 75 && metric['comparison'] < 95) ? "percent-warn" : metric['comparison'] >= 105 ? "percent-good" : ""}>{formatMetric(metricName, metric['comparison'], true)}</td> */}
          return (
            <td className={`${borderClass ? borderClass : ""} ${index == props.subHeaderOrder.length - 1 && last == false ? "lite-border-right" : ""}`} key={index}>
              <div className="lite-table-cell">
                {formatMetric(metricName, metricValue, subHeader)}
              </div>
            </td>
          )
        })}
      </>
    )
  };

  const getColumnName = (metric) => {
    switch (metric) {
      case "spend":
        return "Spend";
      case "clicks":
        return "Clicks";
      case "conversions":
        return "Conversions";
      case "revenue":
        return "Revenue";
      case "roas":
        return "ROAS";
      case "cpa":
        return "CPA";
      case "mer":
        return "MER";
      case "frequency":
        return "Frequency";
      case "conversion_rate":
        return "Conversion Rate";
      case "sessions":
        return "Sessions";
      case "paid_sessions":
        return "Paid Sessions";
      case "organic_sessions":
        return "Organic Sessions";
      case "impressions":
        return "Impressions";
      case "reach":
        return "Reach";
      case "new_customers":
        return "New Customers";
      case "aov":
        return "AOV";
      case "open_rate":
        return "Open Rate";
      case "ctr":
        return "CTR";
      case "bounce_rate":
        return "Bounce Rate";
      case "email_list_growth":
        return "Email List Growth";
      case "affiliates":
        return "Affiliate";
      case "direct":
        return "Direct";
      case "referral":
        return "Referral";
      case "audio":
        return "Audio";
      case "mobile_push_notifications":
        return "Mobile Push Notifications";
      case "sms":
        return "SMS";
      default:
        return startCase(metric);
    }
  }

  const renderTableName = (tableName, selectedGroup = "") => {
    if (selectedGroup != "") {
      selectedGroup = "- " + selectedGroup
    }
    let tableIcon = ""
    if (tableName.toLowerCase().includes("search")) {
      if (selectedGroup.toLowerCase().includes("google ads")) {
        tableIcon = googleAds
      } else if (selectedGroup.toLowerCase().includes("microsoft ads")) {
        tableIcon = microsoftAds
      }
      else tableIcon = searchIcon
    } else if (tableName.toLowerCase().includes("social")) {
      if (selectedGroup.toLowerCase().includes("facebook")) {
        tableIcon = facebook
      } else if (selectedGroup.toLowerCase().includes("tiktok")) {
        tableIcon = tiktokAds
      }
      else tableIcon = socialIcon
    } else if (tableName.toLowerCase().includes("facebook") && tableName.toLowerCase().includes("instagram")) {
      tableIcon = metaAds
    } else if (tableName.toLowerCase().includes("tiktok")) {
      tableIcon = tiktokAds
    } else if (tableName.toLowerCase().includes("youtube")) {
      tableIcon = youtube
    } else if (tableName.toLowerCase().includes("pinterest")) {
      tableIcon = pinterest
    } else if (tableName.toLowerCase().includes("amazon")) {
      tableIcon = amazon
    }

    else tableIcon = ""
    return(
    <div className="lite-flexbox justify-content-center">
      <div className="">
        {tableIcon}
      </div>
      <div className="table-name">
        {tableName} {selectedGroup}
      </div>
    </div>
    )
  }

  return (
    <>
      <div className="metric-table-container" style={props.disabledMsg ? {opacity: "0.5"} : null}>
        <div className={`table-title lite-flexbox justify-content-space-between ${collapsible && 'collapsible'}`}>
          <div className="table-title-left">{renderGroupSelector()}</div>
          <div className={`table-title-center ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>{renderTableName(props.tableName, selectedGroup ? selectedGroup : "")}</div>
          <div className={`table-title-right ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>
            <div className={collapsible ? "" : "d-none"}>
              {isCollapsed ? <>{chevronDown}</> : <>{chevronUp}</>}
            </div>
          </div>
        </div>
        <div className="lite-table-container" ref={tableContainerRef} style={{
          overflow: 'hidden',
          transition: 'max-height 0.5s ease',
          maxHeight: isCollapsed ? '0px' : '1700px'
        }}>
          <table>
            <thead>
              {renderTableHeader()}
            </thead>
            <tbody>
              {renderTopSummaryRow()}
              {renderTableRows()}
            </tbody>
          </table>
        </div>
      </div>
      {props.disabledMsg && (
        <div className="coming-soon-container">
          {props.disabledMsg}
        </div>
      )}
    </>
  );
}
